module.exports = __webpack_public_path__ + "img/ph-active.a2d43e1b.png";